function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { Controller } from 'stimulus';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var _class = /*#__PURE__*/function (_Controller) {
  function _class() {
    _classCallCheck(this, _class);
    return _callSuper(this, _class, arguments);
  }
  _inherits(_class, _Controller);
  return _createClass(_class, [{
    key: "connect",
    value: function connect() {
      if (!this.hasUrlValue) {
        console.error('[stimulus-content-loader] You need to pass an url to fetch the remote content.');
        return;
      }
      this.hasLazyLoadingValue ? this.lazyLoad() : this.load();
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.stopRefreshing();
    }
  }, {
    key: "load",
    value: function load() {
      this.fetch();
      if (this.hasRefreshIntervalValue) {
        this.startRefreshing();
      }
    }
  }, {
    key: "lazyLoad",
    value: function lazyLoad() {
      var _this = this;
      var options = {
        threshold: this.lazyLoadingThresholdValue,
        rootMargin: this.lazyLoadingRootMarginValue || '0px'
      };
      var observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            _this.load();
            observer.unobserve(entry.target);
          }
        });
      }, options);
      observer.observe(this.element);
    }
  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch() {
        return _fetch.apply(this, arguments);
      }
      fetch.toString = function () {
        return _fetch.toString();
      };
      return fetch;
    }(function () {
      var _this2 = this;
      fetch(this.urlValue).then(function (response) {
        return response.text();
      }).then(function (html) {
        _this2.element.innerHTML = html;
        if (_this2.loadScriptsValue) {
          _this2.loadScripts();
        }
      });
    })
  }, {
    key: "startRefreshing",
    value: function startRefreshing() {
      var _this3 = this;
      this.refreshTimer = setInterval(function () {
        _this3.fetch();
      }, this.refreshIntervalValue);
    }
  }, {
    key: "stopRefreshing",
    value: function stopRefreshing() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
      }
    }
  }, {
    key: "loadScripts",
    value: function loadScripts() {
      this.element.querySelectorAll('script').forEach(function (content) {
        var script = document.createElement('script');
        script.innerHTML = content.innerHTML;
        document.head.appendChild(script).parentNode.removeChild(script);
      });
    }
  }]);
}(Controller);
_defineProperty(_class, "values", {
  url: String,
  lazyLoading: Boolean,
  lazyLoadingThreshold: Number,
  lazyLoadingRootMargin: String,
  refreshInterval: Number,
  loadScripts: Boolean
});
export default _class;